import { EnvironmentFeatureFlagStateDto } from '@flagsync/skyline';
import { motion } from 'framer-motion';
import * as React from 'react';

import { cn } from '@/lib/utils';

import { FeatureCarouselCard } from './feature-carousel.card';
import { getItemTransform } from './utils';

const transition = {
  type: 'spring',
  stiffness: 250,
  damping: 30,
  opacity: { duration: 0.3 },
  scale: { duration: 0.3 },
};

const exit = {
  opacity: 0,
  scale: 0.8,
};

export function FeatureCarouselAnimatedCard({
  flag,
  index,
}: {
  flag: EnvironmentFeatureFlagStateDto;
  index: number;
}) {
  const { scale, y, opacity, zIndex } = getItemTransform(index);

  return (
    <motion.div
      layout
      initial={false}
      animate={{
        y,
        scale,
        opacity,
      }}
      exit={exit}
      transition={transition}
      style={{ zIndex }}
    >
      <div
        className={cn(
          'w-full bg-halfmast-1100 rounded-lg p-4 grid grid-cols-[.25fr_1fr_1fr] @-lg:grid-cols-[.5fr_1fr_1fr_1fr] gap-2 @lg:gap-4 h-28 lg:h-32 border-2 border-halfmast-1000 shadow-lg shadow-halfmast-1100 transition-all duration-300',
          {
            'bg-halfmast-1200': index !== 1,
            'opacity-100': index === 0,
          },
        )}
      >
        <FeatureCarouselCard flag={flag} />
      </div>
    </motion.div>
  );
}
